import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, CheckCircle2, FlaskConical, Package } from "lucide-react";
import SEO from "@/components/SEO";
import EnquiryDialog from "@/components/EnquiryDialog";
import { FiveProductArtwork } from "@/components/FiveRangeSection";
import { FIVE_RANGE, fiveProduct } from "@/data/fiveRange";
import { useState } from "react";

export default function FiveRangeDetail() {
  const { slug } = useParams();
  const product = fiveProduct(slug);
  const [enquire, setEnquire] = useState(false);

  if (!product) {
    return <section className="container-fr px-6 py-24"><h1 className="h-section">Product not found</h1><Link className="text-[#2A9D8F]" to="/products">View all products</Link></section>;
  }

  const index = FIVE_RANGE.findIndex((item) => item.slug === product.slug);
  const next = FIVE_RANGE[(index + 1) % FIVE_RANGE.length];

  return (
    <>
      <SEO title={product.name + " | Animal Feed Supplement"} description={product.description} path={"/five-range/" + product.slug} />
      <section className="bg-[#F8FAFC] py-16 lg:py-24">
        <div className="container-fr px-6 md:px-12 lg:px-20">
          <Link to="/products#our-key-products" className="text-[#2A9D8F] text-sm font-semibold inline-flex items-center gap-2 mb-9"><ArrowLeft size={16} /> All Key Products</Link>
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <FiveProductArtwork product={product} />
            <div>
              <span className="overline">Forage Five Range</span>
              <h1 className="font-display text-4xl lg:text-5xl font-black text-[#0B2545] mt-3">{product.name}</h1>
              <p className="text-slate-600 mt-4 text-lg leading-relaxed">{product.description}</p>
              <p className="text-slate-500 text-sm mt-4">Suitable for: {product.audience}</p>
              <h2 className="text-xl font-display font-bold text-[#0B2545] mt-8">Key benefits</h2>
              <ul className="mt-4 space-y-3">
                {product.benefits.map((benefit) => <li key={benefit} className="flex gap-3 text-slate-700"><CheckCircle2 className="text-[#2A9D8F] mt-0.5 shrink-0" size={18} />{benefit}</li>)}
              </ul>
              <button type="button" onClick={() => setEnquire(true)} className="btn-accent mt-9">Enquire about {product.shortName} <ArrowRight className="ml-2" size={16} /></button>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-8 mt-14">
            <div className="rounded-xl border border-slate-200 bg-white p-8">
              <FlaskConical className="text-[#2A9D8F]" />
              <h2 className="font-display text-2xl font-bold text-[#0B2545] mt-4">Key formulation ingredients</h2>
              <p className="text-sm text-slate-500 mt-3">Ingredient overview, not a complete quantitative composition. Please request a current technical datasheet for specifications.</p>
              <ul className="mt-5 list-disc pl-5 space-y-2 text-slate-700">{product.keyIngredients.map((ingredient) => <li key={ingredient}>{ingredient}</li>)}</ul>
            </div>
            <div className="rounded-xl border border-slate-200 bg-white p-8">
              <Package className="text-[#2A9D8F]" />
              <h2 className="font-display text-2xl font-bold text-[#0B2545] mt-4">Available pack sizes</h2>
              <div className="flex gap-2 flex-wrap mt-5">{product.packs.map((pack) => <span key={pack} className="text-sm bg-[#F8FAFC] border border-slate-200 rounded-full px-4 py-2">{pack}</span>)}</div>
              <p className="text-sm text-slate-500 mt-6">Animal feed supplement. Not intended for human use. Follow the current product label and veterinarian's instructions for usage.</p>
            </div>
          </div>
          <div className="flex flex-wrap gap-4 items-center justify-between border-t border-slate-200 pt-9 mt-12">
            <span className="text-sm text-slate-500">For a current composition sheet and literature PDF, please contact our team.</span>
            <Link to={"/five-range/" + next.slug} className="text-[#2A9D8F] font-semibold inline-flex items-center gap-2">Next: {next.shortName} <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
      <EnquiryDialog open={enquire} onOpenChange={setEnquire} product={product} />
    </>
  );
}
